// TODO: https://welltech.atlassian.net/browse/UPP-90

export default {
  onboarding: process.env.ENV === 'prod' ? 'https://walk-fit.io' : 'https://walking-front-stage.asqq.io',

  termsOfUse: 'https://legal.walkfit.pro/page/terms-of-use',
  privacyPolicy: 'https://legal.walkfit.pro/page/privacy-policy',
  refundPolicy: 'https://legal.walkfit.pro/page/refund-policy',
};
